module.exports = __webpack_public_path__ + "media/images/result_sets/circles/9n1r3n6r-0ec175d2c0817a980612de123bc72ade.svg";